export function findData(id) {
  return {
    type: '@logsdescarregamentos/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@logsdescarregamentos/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@logsdescarregamentos/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@logsdescarregamentos/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@logsdescarregamentos/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@logsdescarregamentos/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@logsdescarregamentos/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@logsdescarregamentos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@logsdescarregamentos/RECORD_FILTERING',
    payload: { params },
  };
}
